export const deviceTypes = Object.freeze({
  DESKTOP: 0,
  MOBILE: 1,
  TABLET: 2,
})
export const browserTypes = Object.freeze({
  CHROME: 0,
  FIREFOX: 1,
  SAFARI: 2,
  EDGE: 3,
  INTERNET_EXPLORER: 4,
  OTHER: 5
})
export const osTypes = Object.freeze({
  WINDOWS: 0,
  MAC: 1,
  LINUX: 2,
  UNIX: 3,
  IOS: 4,
  ANDROID: 5,
  OTHER: 6
})
